export const convertToValidDate = (date: Date | string) => {
  const newDate = new Date(date)
  const dateFormatter = Intl.DateTimeFormat('sv-SE')
  return dateFormatter.format(newDate)
}
